import { FC, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { WorkspaceSelector } from '../../WorkspaceSelector';

type SidebarNavigationProps = { className?: string } & PropsWithChildren;

export const SidebarNavigation: FC<SidebarNavigationProps> = ({ className, children }) => {
  return (
    <nav className='flex grow flex-col gap-1'>
      <WorkspaceSelector />
      <ul className={twMerge('flex flex-col gap-1 grow', 'motion-safe:transition-[padding] motion-safe:duration-500 motion-reduce:transition-none', className)}>
        {children}
      </ul>
    </nav>
  );
};
